import { Platform } from 'quasar'
import { $logger } from '@/boot/logger'
import { isTrueProduction } from '@/utils/env.util'

/**
 * Blocks /app/* routes on non-native platforms in production.
 * In non-production environments, access is allowed if the peg_debug localStorage flag is set.
 *
 * Registered at the router level (not in a component) so it runs on initial navigation.
 */
export function blockAppRoutesOnWeb(to) {
  if (to.path.startsWith('/app') && !Platform.is.nativeMobile && (isTrueProduction() || !localStorage.getItem('peg_debug'))) {
    $logger.debug('NAV GUARD: BLOCKED /app ROUTE ON NON-NATIVE', to.path)
    return { name: 'Home' }
  }
}
